<template>
  <div id="app">
    <h1>Word Finder</h1>
    <div class="inline">
      <el-input type="text" v-model="input" ref="input" id="input" placeholder="pattern" clearable/>
      <el-button @click="addWC()" icon="el-icon-star-off"/>
      </div>
    <el-input type="text" v-model="available" placeholder="available" clearable/>
    <el-input disabled :value="longPattern()" size="small"/>
    <br/>
    <el-button @click="search" type="primary" icon="el-icon-search">Search</el-button>

    <br/><br/><br/>
    <el-card title="Results">
      {{ results }}
    </el-card>
  </div>
</template>

<script>
export default {
  name: "app",
  data: () => {
    return {
      input: "",
      available: "",
      words: [],
      results: []
    };
  },
  created() {
    require("!raw-loader!./assets/words.txt").split('\r').forEach(word => {
      this.words.push(word.replace('\n', ''))
    })
  },
  methods: {
    addWC(){
      this.input+='*'
      document.getElementById('input').focus()
    },
    search() {
      let reg = new RegExp(this.longPattern(), 'gm');
      this.results = [];
      
      this.words.forEach(word => {
        if (reg.test(word)) {
          this.results.push(word);
        }
      })
    },
    shortPattern(){
      let pattern = '['
      for(let i = 0; i<this.available.length; i++) {
        let letter = this.available[i].toLowerCase()
        pattern+=letter
      }
      pattern+="]"
      return pattern
    },
    longPattern(){
      let pattern = '^'
      for(let i = 0; i<this.input.length; i++) {
        let letter = this.input[i].toLowerCase()
        if(letter === '*') {
          pattern+=this.shortPattern()
        } else {
          pattern+=letter
        }
      }
      pattern+='$'
      return pattern
    }
  }
};
</script>

<style>
html, body, #app {
  background-color: beige;
}
body {
  display: flex;
  justify-content: space-around;
}
#app {
  font-family: "Avenir", Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  margin-top: 60px;
  max-width: 1024px;
}

.inline {
  display: flex;
}
</style>
